import React from 'react'
import Icon from './Icon'
import coffeeIcon from './assets/Icons/coffee-cup.png'
import icecreamIcon from './assets/Icons/ice-cream.png'
import indiaIcon from './assets/Icons/india (1).png'


function About({aboutRef}) {

  return (
    <div className="about_container" ref={aboutRef}>
        <div className="about_header header_container"><span>About</span></div>
        <div className="about_content">
            <div className="left_section">
                <div className="about_content_header">
                    a developer based in Ahmedabad, India <Icon width="32px" icon={indiaIcon}/>
                </div>
                <div className="about_content_para">    
                    I was born and raised in Ahmedabad, who's passionate about creating digital experiences through problem-solving. 
                </div>
                
                <div className="about_content_para">My main expertise lies in back-end development, though I do dabble in front-end.</div>                 
                <a className="take_my_CV" href="/Nikhil-Mandaliya-Resume.pdf" target="blank">CV</a>
            </div>
            <div className="right_section">
                <span className="list_header"><Icon width="30px" icon={icecreamIcon} /> What i like</span>
               <ul className="list_item">
                   <li>Creating Websites</li>
                   <li>Sketching</li>
                   <li>Video Games</li>
                </ul>
                <span className="list_header"><Icon width="30px" icon={coffeeIcon} /> What i am learning</span>
               <ul className="list_item">
                   <li>React</li>
                   <li>Sass</li>
                   <li></li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default About